/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Types
import 'libs/utils/typedefs';

/**
 * This component is used to provide in-product tours of modules needed to create a minimal workspace.
 *
 * @vue-prop {String} eventId the event ID
 *
 * @category ui.components
 * @exports Checklist
 * @component
 */
const __vue_script__ = {
    name: 'Checklist',

    props: {
        eventId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            expanding: false,
            collapsing: false,
            animating: false,
            expanded: false,
            steps: []
        };
    },

    computed: {
        /**
         * Used to check how many tasks are done
         *
         * @returns {Number} the number of completed tasks
         */
        done() {
            return this.steps.filter(step => step.checked).length;
        },

        /**
         * Used to get the checklist completion rate
         *
         * @returns {Number} the completion rate
         */
        completion() {
            return !this.steps.length ? 100 : (this.done / this.steps.length) * 100;
        }
    },

    watch: {
        expanded() {
            this.animating = true;
            this.collapsing = !this.expanded;
            this.expanding = this.expanded;

            setTimeout(() => {
                this.animating = false;
                this.collapsing = false;
                this.expanding = false;
            }, 400);
        }
    },

    async created() {
        try {
            this.steps = await this.$services.event.getChecklist(this.eventId) || []; // We could receive `null` checklist if no checklist is configured
            this.registerToSignals();
        } catch (error) {
            console.info('[Checklist] An error occurred while getting the checklist:', get(error, 'response.statusText'));
        }
    },

    destroyed() {
        this.unregisterFromSignals();
    },

    methods: {
        /**
         * Redirect the user to clicked step.
         *
         * @param {ChecklistItem} step the step to go to
         */
        goTo(step) {
            if (step.checked) {
                return;
            }

            let immediateTour = true;

            if (step.module) {
                const module = this.$services.blueprint.getModuleByName(step.module);

                if (!module) {
                    console.warn('[Checklist] No module found or installed:', step.module);
                    return;
                }

                console.info('[Checklist] Heading to', step);

                const params = { eventId: this.eventId };
                const searchParams = module.searchParams || {};
                const ctrl = step.controller ? module.controllers[step.controller] : module;
                const path = this.$utils.blueprint.getLinkForModule(ctrl, params, searchParams);

                // An eventual tour will be called after the page has changed
                immediateTour = path === window.location.pathname;

                this.$router.push(path);
            }

            if (step.tour_id) {
                console.info('[Checklist] Starting tour with ID', step.tour_id);
                this.$services.track.showTour(step.tour_id, immediateTour);
            }

            // Collapse the checklist
            this.expanded = false;
        },

        /**
         * Notifies the user with a flash message that a task
         * has been completed.
         */
        notifyTaskCompletion() {

            this.$track('checklist_progress', { percentage: this.completion });

            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('checklist.task_completed').toString(),
                type: 'success'
            });
        },

        /**
         * Websocket handler for checklist update
         *
         * @param {Object} data the data object that contains the checklist
         * @param {Checklist} data.checklist the updated checklist
         */
        updateChecklist({ checklist = [] }) {
            if (checklist && checklist.filter(task => task.checked).length === this.done) {
                return;
            }

            console.info('[Checklist] Received checklist update', checklist);
            this.steps = checklist || []; // We could receive `null` checklist if no checklist is configured
            this.notifyTaskCompletion();

            if (this.completion >= 100) {
                this.unregisterFromSignals();
            }
        },

        /**
         * Registers checklist signal listener
         */
        registerToSignals() {
            if (this.steps.length && this.done !== this.steps.length) {
                console.info('[Checklist] Registering to signals', this.$const.CHECKLIST_CHANNEL);
                this.$services.signal.addSignalListener(this.$const.CHECKLIST_CHANNEL, this.updateChecklist);
            } else {
                console.info('[Checklist] No need to register to signals');
            }
        },

        /**
         * Unregisters checklist signal listener
         */
        unregisterFromSignals() {
            console.info('[Checklist] Unregistering from signals', this.$const.CHECKLIST_CHANNEL);
            this.$services.signal.removeSignalListener(this.$const.CHECKLIST_CHANNEL, this.updateChecklist);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.steps.length
    ? _c(
        "div",
        {
          staticClass: "checklist",
          class: {
            expanded: _vm.expanded,
            animating: _vm.animating,
            expanding: _vm.expanding,
            collapsing: _vm.collapsing,
          },
        },
        [
          _c("header", [
            _c(
              "div",
              {
                staticClass: "handler",
                on: {
                  click: function ($event) {
                    _vm.expanded = !_vm.expanded
                  },
                },
              },
              [
                _c("progress-ring", {
                  staticClass: "secondary",
                  attrs: { progress: _vm.completion },
                }),
                _c("i", { staticClass: "ic-chevron-up" }),
                _c("span", { staticClass: "counters" }, [
                  _vm._v(_vm._s(_vm.done) + "/" + _vm._s(_vm.steps.length)),
                ]),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("checklist.title"))),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "completion" }, [
              _c(
                "div",
                { staticClass: "details" },
                [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(_vm._s(_vm.$t("checklist.progress"))),
                  ]),
                  _c("progress-bar", {
                    staticClass: "secondary",
                    attrs: { progress: _vm.completion },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("section", [
            _c(
              "ul",
              { staticClass: "todo-list details" },
              _vm._l(_vm.steps, function (step) {
                return _c(
                  "li",
                  {
                    class: { "has-action": !step.checked },
                    on: {
                      click: function ($event) {
                        return _vm.goTo(step)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "checkmark" }, [
                      step.checked
                        ? _c("i", { staticClass: "ic-check-square" })
                        : _c("span", { staticClass: "unchecked" }),
                    ]),
                    _vm._m(0, true),
                    _c("div", { staticClass: "step" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$utils.locales.localizeLabel(
                              step.name,
                              _vm.$i18n.locale
                            )
                          )
                        ),
                      ]),
                      step.description
                        ? _c("div", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$utils.locales.localizeLabel(
                                  step.description,
                                  _vm.$i18n.locale
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-suggestion" }, [
      _c("i", { staticClass: "ic-arrow-right" }),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/Checklist.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__